import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { TimeAgoPipe } from '../../pipes/time-ago.pipe';

/**
 * Reusable Facebook-style notification dropdown body. Renders the list with unread state,
 * relative time ("il y a 3 min") and the delivery time. The parent keeps the click routing
 * (it differs per role) by handling (itemClick).
 */
@Component({
  selector: 'app-notification-panel',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, TimeAgoPipe],
  templateUrl: './notification-panel.component.html',
  styleUrl: './notification-panel.component.scss',
})
export class NotificationPanelComponent {
  @Input() notifications: any[] | null = [];
  @Output() itemClick = new EventEmitter<any>();

  get unreadCount(): number {
    return (this.notifications || []).filter((n) => !n?.read).length;
  }

  /** Strips the hidden [ETB_LINK:...] routing marker from the displayed text. */
  getDisplayContent(content: string): string {
    if (!content) {
      return '';
    }
    return content.replace(/\[ETB_LINK:[^\]]+\]/g, '').trim();
  }

  formatDeliveredTime(value: string): string {
    if (!value) {
      return '';
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      return '';
    }
    return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  }

  onItemClick(item: any, ev: Event): void {
    ev.stopPropagation();
    this.itemClick.emit(item);
  }

  trackById = (_: number, item: any) => item?.id ?? _;
}
